module.exports = __webpack_public_path__ + "static/media/Bulk Upload Product Status Dealshub.6aa7d728.xlsx";